export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-1.23485d9d.png";